import { deleteOldestMetric, saveMetricToDB } from '@/utils/db';
import { useEffect, useRef } from 'react';
import { envIsElectron } from 'src/const/envCheck';
import useOnlineStatus from 'src/hooks/useOnlineStatus';
import { StatisticService } from 'src/services/statistics/statistic.service';
import { Statistic } from 'src/types/statistics/Statistics';

const useStatisticsSaver = () => {
  const isOnline = useOnlineStatus();
  const isOnlineRef = useRef(isOnline);

  useEffect(() => {
    isOnlineRef.current = isOnline;
  }, [isOnline]);

  const saveStats = async (statistic: unknown) => {
    const actualStatistics = statistic as Statistic;
    if (isOnlineRef.current) {
      await StatisticService.uploadStatistic(actualStatistics);
    } else {
      await saveMetricToDB(
        actualStatistics.metrics.metricName,
        actualStatistics,
      );
    }
  };

  const bulkUploadStats = async () => {
    if (isOnlineRef.current) {
      const oldestStatistic = await deleteOldestMetric();
      if (!oldestStatistic) {
        console.debug('[STATISTICS] No more metrics to sync.');
        return;
      }
      await StatisticService.uploadStatistic(oldestStatistic.statistic);
      setTimeout(bulkUploadStats, 2000);
    }
  };

  useEffect(() => {
    if (!envIsElectron) {
      return;
    }
    const savestatistics = window.electron.ipcRenderer.on(
      'saveStatistic',
      saveStats,
    );
    return () => {
      savestatistics();
    };
  }, []);

  useEffect(() => {
    if (!envIsElectron) {
      return;
    }
    if (isOnline) {
      console.debug('[STATISTICS] Uploading Statistics...');
      bulkUploadStats();
    }
  }, [isOnline]);
};

export default useStatisticsSaver;
